// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"86319e9f","314":"833362ee","404":"e16b2318","689":"4670f8f9"}[chunkId] + ".chunk.js";
};